// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css, ThemeProvider } from 'styled-components';

import colors from '../config/colors';
import themes from '../config/themes/index';

import { buttonStyles } from '../components/Button';
import ContainedImage from '../components/ContainedImage';
import Icon from '../components/Icon';

const ToolWrapper = styled.div`
  background-color: ${({ brand }) => colors[brand].brand};
  border-radius: 8px;
  color: white;
  padding: 1em 1em 1.5em;
  text-align: center;
  p {
    font-size: 14px;
    line-height: 1.4;
    margin-top: 0;
  }

  @media (min-width: 375px) {
    padding: 1em 1.5em 1.5em;
    p {
      font-size: 15px;
    }
  }
`;

const Brand = styled(ContainedImage).attrs({
  image: props => props.theme.brandImage,
  width: '100px',
  height: '60px'
})`
  margin: auto;
  max-width: 100px;
  min-width: 50px;
  width: 100%;
`;

const Intro = styled.div`
  ${props => window.Modernizr.flexbox && css`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
    ${Brand} {
      margin: 0;
    }
    p {
      margin: 0;
      padding-left: 1em;
      text-align: left;
    }
  `}
`;

const UseButton = styled(Link)`
  ${buttonStyles}
  color: ${props => props.theme.brand};
  font-weight: bold;
  text-transform: uppercase;
`;

type Props = {
  brand: string
}

const Tool = ({ brand }: Props) => (
  <ToolWrapper className="tool limit-width" brand={brand}>
    <ThemeProvider theme={themes[brand]}>
      <div>
        <Intro>
          <Brand />
          <p>Use the Vortex Shaft Mount Calculator and download specs.</p>
        </Intro>
        <UseButton data-size="sm" to={`/tools/${brand}`}>
          <Icon size={18} type="wrench" withMargin={true} />
          Use this tool
        </UseButton>
      </div>
    </ThemeProvider>
  </ToolWrapper>
);

export default Tool;



// WEBPACK FOOTER //
// ./src/components/Tool.js